import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { Color, ColorFilters } from '../../models/Color';

const useColorService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetColors, setFetchingGetColors] = useState(false);
    const [fetchingStoreColor, setFetchingStoreColor] = useState(false);
    const [fetchingEditColor, setFetchingEditColor] = useState(false);
    const [fetchingUpdateColor, setFetchingUpdateColor] = useState(false);
    const [fetchingDeleteColor, setFetchingDeleteColor] = useState(false);
    const [fetchingActiveColor, setFetchingActiveColor] = useState(false);

    const getColors = (filters: ColorFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== null && value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        const url = `${EndPoints.COLORS.GET_COLORS}?${queryString}`;

        doGet({
            ...events,
            url: url,
            setFetching: setFetchingGetColors
        });
    };

    const storeColor = (color: Color, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.COLORS.STORE_COLOR,
            body: color,
            requestType: 'json',
            setFetching: setFetchingStoreColor
        });
    };

    const editColor = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.COLORS.EDIT_COLOR.replace(':id', id.toString()),
            setFetching: setFetchingEditColor
        });
    };

    const updateColor = (id: number, color: Color, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.COLORS.UPDATE_COLOR.replace(':id', id.toString()),
            body: color,
            requestType: 'json',
            setFetching: setFetchingUpdateColor
        });
    };

    const deleteColor = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.COLORS.DELETE_COLOR.replace(':id', id.toString()),
            setFetching: setFetchingDeleteColor
        });
    };

    const activeColor = (id: number, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.COLORS.ACTIVE_COLOR.replace(':id', id.toString()),
            body: {},
            requestType: 'json',
            setFetching: setFetchingActiveColor
        });
    };

    return {
        fetchingGetColors,
        fetchingStoreColor,
        fetchingEditColor,
        fetchingUpdateColor,
        fetchingDeleteColor,
        fetchingActiveColor,
        getColors,
        storeColor,
        editColor,
        updateColor,
        deleteColor,
        activeColor
    };
};

export default useColorService;
